import { StyleSheet } from 'react-native'
import { COLORS } from '@utils/colors'

export const primaryButtonStyles = StyleSheet.create({
  button: {
    paddingHorizontal: 50,
    minHeight: 44,
    borderRadius: 22,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 20,
    flexDirection: 'row',
  },
  contained: {
    backgroundColor: COLORS.primary.lightBlue,
  },
  link: {
    backgroundColor: 'transparent',
  },
  outlined: {
    borderWidth: 1,
    borderColor: COLORS.primary.darkGray,
  },
  containedTitle: {
    color: COLORS.primary.white,
  },
  outlinedTitle: {
    color: COLORS.primary.darkGray,
  },
  linkTitle: {
    color: COLORS.primary.error,
  },
})
